module.exports = __webpack_public_path__ + "images/logo-opus.jpg?0c25b627dd8588508c35543e0cc5c043";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/fidelidade/logo-opus.jpg
// module id = 984
// module chunks = 0